import type { AcceptCryptoLegalDocMutation } from '../../__generated__/graphql'

export enum CryptoConsentSource {
    LOGIN_POPUP = "LOGIN_POPUP",
    SIGN_UP = "SIGN_UP",
}

export type AcceptCryptoLegalDocData = {
    accessToken: string
    companyId?: string
    cryptoProviderTermsId: number
    source: CryptoConsentSource
}

export type AcceptCryptoLegalDocResponse = {
    data: AcceptCryptoLegalDocMutation
}
